<template>
  <b-modal
    ref="create-confirm-modal"
    hide-footer
    hide-header
    id="upload-image-modal"
    no-close-on-backdrop
  >
    <div
      class="modal__title--tab"
    >
      <a
        v-if="tabs.includes('upload')"
        @click="handleTabChange('upload')"
        :class="{ active: selectedTab === 'upload' }"
      >
        {{ $i18nPresenter.t('Upload') }}
      </a>
      <a
        v-if="tabs.includes('myPhoto')"
        @click="handleTabChange('myPhoto')"
        :class="{ active: selectedTab === 'myPhoto' }"
      >
        {{ $i18nPresenter.t('My Images') }}
      </a>
      <a
        v-if="tabs.includes('unsplash')"
        @click="handleTabChange('unsplash')"
        :class="{ active: selectedTab === 'unsplash' }"
      >
        <span class="d-none d-xl-block d-lg-block d-md-block">{{ $i18nPresenter.t('Stock Photos') }}</span>
        <span class="d-block d-md-none">{{ $i18nPresenter.t('Photos') }}</span>
      </a>
      <a
        v-if="tabs.includes('giphy')"
        @click="handleTabChange('giphy')"
        :class="{ active: selectedTab === 'giphy' }"
        class="tab-giphy __wrapper"
      >
        <span class="d-none d-xl-block d-lg-block d-md-block">{{ $i18nPresenter.t('GIFs & Stickers') }}</span>
        <span class="d-block d-md-none">{{ $i18nPresenter.t('GIFs') }}</span>
        <span :class="{'d-none': hasUsedGiphy}" class="tab-giphy __icon">
          <img alt="giphy-star-icon" :src="require('@/assets/images/icon/star.gif')">
        </span>
      </a>
    </div>
    <div class="close-modal" @click="hide">
      <i class="fas fa-times" />
    </div>

    <Uploader
      v-if="isLoading"
    />

    <div
      class="tab-content"
      v-if="selectedTab === 'upload'"
      style="overflow: hidden;"
      :class="{'tab-upload': selectedTab === 'upload'}"
    >
      <label
        for="upload-file"
        class="horizontal layout center center-justified"
        :class="{'error': error, 'uploaded': uploadDone}"
      >
        <div v-if="!uploadDone">
          <div v-if="!isLoading">
            <i class="far fa-image fa-4x" />
            <h3 class="dropzone-custom-title">
              <span v-html="$i18nPresenter.t('pasteDropBrowser')"></span>
            </h3>
            <div class="subtitle">{{ $i18nPresenter.t('Up to 15 MB.') }}</div>
            <div class="p-subtitle">.png .jpg .gif .svg</div>

            <div class="error-text text-danger" v-if="error">{{ error }}</div>
          </div>
        </div>
        <div class="image-upload-done" v-if="uploadDone">
          <img :src="$store.state.slideActive.image.large" alt>
        </div>
        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          accept="image/*"
          id="upload-file"
          v-if="!isLoading"
          drop-placeholder="drop image"
          :file-name-formatter="onFileSelect"
        />
      </label>
    </div>
    <MyPhoto
      v-show="selectedTab === 'myPhoto'"
      @selectExistImage="(obj) => $emit('selectExistImage', obj)"
      @changeUploadTab="handleTabChange('upload')"
    />
    <div
      class="tab-content"
      v-show="selectedTab === 'unsplash'"
      id="infinite-list"
    >
      <div class="input-search">
        <b-form-input
          v-model="text"
          :placeholder="$i18nPresenter.t('Search photos from Unsplash..')"
          @input="searchPhotoUnsplash(1,false)"
          ref="unsplash-search-input"
        />
      </div>
      <div class="list-image">
        <p v-if="noResultText" class="list-image--no-result">
          {{ noResultText }}
        </p>
        <div class="pt-0 item-image" v-for="(item,index) in splashPhotos" :key="index">
          <div
            class="img-bg"
            :style="{ 'background-image': 'url(' + item.urls.small + ')' }"
            @click.self="selectImage(getUnsplashImageUrl(item), 'unsplash', item)"
          >
            <div class="img-info">
              Photo by <a class="img-info__link" :href="'https://unsplash.com/' + item.user.username + '?utm_source=ahaslides&utm_medium=referral'" target="_blank">{{ item.user.name }}</a> on <a class="img-info__unsplash-link" href="https://unsplash.com/?utm_source=ahaslides&utm_medium=referral" target="_blank">Unsplash</a>
            </div>
          </div>
        </div>
      </div>
      <Loading
        style="margin: 0 auto; width: 100%;"
        :class="{'hide-loading-image': !isLoadingImg}"
      />
    </div>
    <div
      class="tab-content list-giphy-container"
      v-show="selectedTab === 'giphy'"
      id="infinite-giphy-list"
    >
      <div class="search-giphy-group">
        <div class="input-search">
          <b-form-input
            v-model="text"
            :placeholder="getBFormSearchGiphyPlaceHolder"
            @input="searchPhotoGiphy(30,0,false)"
            ref="giphy-search-input"
          />
        </div>
        <div class="btn-giphy--type">
          <div
            v-if="giphyTypes.includes('gif')"
            @click="handleGiphyTypeChange('gif')"
            class="item gif"
            :class="{ active: giphyType === 'gif' }"
          >
            <span>GIFs</span>
          </div>
          <div
            v-if="giphyTypes.includes('sticker')"
            @click="handleGiphyTypeChange('sticker')"
            class="item sticker"
            :class="{ active: giphyType === 'sticker' }"
          >
            <span>{{ $i18nPresenter.t('Stickers') }}</span>
          </div>
        </div>
      </div>
      <div class="list-image">
        <p v-if="noResultText" class="list-image--no-result">
          {{ noResultText }}
        </p>
        <div class="pt-0 item-image" v-for="(item,index) in giphyPhotos" :key="index">
          <div class="item-image-group">
            <div v-if="giphyType === 'sticker'" class="bg-sticker"></div>
            <div
              class="img-bg"
              :style="{ 'background-image': 'url(' + item.images.preview_gif.url + ')',
                        'background-size': giphyType === 'sticker' ? 'contain' : 'cover' }"
              @click="selectImage(
                getGiphyImageUrl(item), giphyType === 'gif' ? 'giphy' : 'giphy stickers', item)"
              ref="giphyImg"
            >
              <div class="img-info">
                <img
                  alt="PoweredbyGiphy"
                  src="../../assets/images/Poweredby_100px-Black_VertLogo.png"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loading
        style="margin: 0 auto; width: 100%;"
        :class="{'hide-loading-image': !isLoadingImg}"
      />
      <ModalUploadImageError
        v-if="hasErrorOnUploadingGiphy"
        @handleOkButtonClick="handleOKButtonOnModalUploadImageError()"
      />
    </div>
  </b-modal>
</template>

<script>
import debounce from 'debounce'
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'
import constants from '@/constant'
import Config from '@/config'
import Socket from '@/socket'
import Loading from '@/components/Loading'
import Utils from '@/util'
import storageKeys from '@/constant/storageKeys'
import UserApi from '@/api/user'
import { dataURLToBlob } from '@/utils/indexedDB/image.cache.utils'
import eventCategories from '@/constant/eventCategories'

// UI
import Uploader from '@/components/UI/loaders/Uploader'
import ModalUploadImageError from '@/components/UI/modals/UploadImageError.vue'
import PasteImageMixin from '@/mixins/presentation/PasteImageMixin'
import MyPhoto from '@/components/presentations/MyPhoto.vue'

export default {
  components: {
    Loading,
    Uploader,
    ModalUploadImageError,
    MyPhoto,
  },
  mixins: [PasteImageMixin],
  props: {
    type: {
      type: String,
      default: null,
    },
    expires: { // expiration of signed url by CloudFront
      type: Number,
      default: null,
    },
    updateGifInBackground: {
      type: Function,
      default: null,
    },
    giphyTypes: {
      type: Array,
      default: () => ['gif', 'sticker'],
    },
  },
  data() {
    return {
      tabs: ['upload', 'myPhoto', 'unsplash', 'giphy'],
      text: '',
      giphyPhotos: [],
      splashPhotos: [],
      file: null,
      error: '',
      isLoading: false,
      uploadDone: false,
      isLoadingImg: false,
      previousSearchText: '',
      noResultText: '',
      noMoreGiphyResult: false,
      noMoreUnsplashResult: false,
      hasErrorOnUploadingGiphy: false,
      giphyType: 'sticker',
      isHasUsedGiphyAPIDone: false,
    }
  },
  computed: {
    ...mapGetters(['selectedSlides']),
    ...mapState({
      selectedTab: (state) => state.selections.selectedTab,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
    }),
    hasUsedGiphy() {
      return this.currentUser && this.currentUser.personalInformation &&
        this.currentUser.personalInformation.hasUsedGiphy
    },
    getBFormSearchGiphyPlaceHolder() {
      if (this.giphyType === 'gif') return this.$i18nPresenter.t('Search GIFs from GIPHY..')
      return this.$i18nPresenter.t('Search Stickers from GIPHY..')
    },
  },
  mounted() {
    this.show()
    this.handleTabChange(this.selectedTab, true) // default tab: 'upload'
    setTimeout(() => {
      this._setUnslashGiphyInfiniteScroll()
    }, 1000)

    setTimeout(() => {
      // Prevent deselect
      document.getElementById('upload-image-modal').addEventListener('mouseup', (e) => {
        e.stopPropagation()
      }, true)
    }, 0)
  },
  methods: {
    ...mapActions(['setSelectedTabAction', 'updateSlideActiveAction', 'setCurrentUserAction']),
    _checkToUpdateUserHasUsedGiphy() {
      const key = storageKeys.HAS_USED_GIPHY
      const timeUsedGiphy = localStorage.getItem(key)
      if (!timeUsedGiphy) {
        localStorage.setItem(key, 1)
      } else {
        localStorage.removeItem(key)
        this._callAPIToUpdateHasUsedGiphy()
      }
    },
    async _callAPIToUpdateHasUsedGiphy() {
      try {
        await UserApi.patchUserById(this.currentUser.id, {
          personalInformation: {
            hasUsedGiphy: true,
          },
        })
        this.isHasUsedGiphyAPIDone = true
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    _setUnslashGiphyInfiniteScroll() {
      const listElm = document.querySelector('#infinite-list')
      const listGiphy = document.querySelector('#infinite-giphy-list')
      if (listElm) {
        listElm.addEventListener('scroll', () => {
          if (this.noMoreUnsplashResult) return
          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight - 50) {
            this.unsplashInfinite()
          }
        })
      }

      if (listGiphy) {
        listGiphy.addEventListener('scroll', () => {
          if (this.noMoreGiphyResult) return
          if (listGiphy.scrollTop + listGiphy.clientHeight >= listGiphy.scrollHeight - 50) {
            this.giphyInfinite()
          }
        })
      }
    },
    onFileSelect(files) {
      this.uploadFile(files)
      this.trackUploadImage('manual_upload')
    },
    async resizeImage(file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = function (readerEvent) {
          const image = new Image()
          image.onload = function () {
          // Resize the image
            const canvas = document.createElement('canvas')
            const max_size = 1024
            let { width, height } = image

            if (width > height) {
              if (width > max_size) {
                height *= max_size / width
                width = max_size
              }
            } else if (height > max_size) {
              width *= max_size / height
              height = max_size
            }
            canvas.width = width
            canvas.height = height
            canvas.getContext('2d', { alpha: true }).drawImage(image, 0, 0, width, height)
            const dataUrl = canvas.toDataURL(file.type)
            const resizedImage = dataURLToBlob(dataUrl)
            const resizedFile = new File([resizedImage], file.name, {
              type: file.type,
            })
            resolve(resizedFile)
          }
          image.src = readerEvent.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    async uploadFile(files) {
      if (!files || !files.length) return

      const file = files[0]

      if (file && file.size > 15728640) {
        this.error = 'Could not upload this file (max size is 15 MB).'
        return
      }

      const errorString = 'Could not upload this file (only support image file jpg, svg, gif, png, ...).'
      if (file.type && !file.type.includes('image')) {
        this.error = errorString
        return
      }

      this.error = ''
      this.isLoading = true
      const formData = new FormData()

      formData.append('file', file)
      if (this.expires) {
        formData.append('expires', this.expires)
      }
      formData.append('accessCode', this.$store.state.presentation.uniqueAccessCode)
      formData.append('socketId', Socket.getSocketId())
      formData.append('type', this.type)

      if (file.type === 'image/gif') {
        // need to infer the gif image dimension to be insert as a block
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => {
          const image = new Image()
          image.src = e.target.result
          image.onload = () => {
            file.width = image.width
            file.height = image.height
          }
        }
      }

      try {
        const res = await this.$http.post(Config.api.uploadImage, formData)
        if (file.type === 'image/gif') {
          await this.updateGifInBackground({
            imageUrl: res.body.file.location,
            selectedSlides: this.selectedSlides,
            imageDimension: {
              width: file.width,
              height: file.height,
            },
          })
        } else {
          this.$emit('callback', res.body.file.location, 'manual_upload', file)
        }
      } catch (error) {
        if (error.body && error.body.code === 'file_not_supported') {
          this.error = errorString
        } else {
          this.error = 'Cannot upload file. Please try again.'
        }

        this.isLoading = false
        throw error
      }
    },
    async selectImage(url, source, image) {
      this.hasErrorOnUploadingGiphy = false
      this.isLoading = true

      const extension = url.split('?')[0].split('.').pop()

      if (extension === 'gif') {
        try {
          const imageUrl = this.getGiphyImageUrl(image)
          await this.updateGifInBackground({
            imageUrl,
            selectedSlides: this.selectedSlides,
            imageDimension: {
              width: image.images.original.width,
              height: image.images.original.height,
            },
          })
          this.trackUploadImage(source)
        } catch (error) {
          this.hasErrorOnUploadingGiphy = true
          this.isLoading = false
        }
        return
      }

      this.$emit('callback', url, source)
      this.trackUploadImage(source)
    },

    show() {
      this.uploadDone = false
      this.$refs['create-confirm-modal'].show()
      Utils.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Open Upload modal', null, null, {
        slideId: this.slideActive.id,
      })
    },
    hide() {
      this.$emit('hideModal')
      if (this.isHasUsedGiphyAPIDone) {
        const userPayload = {
          personalInformation: {
            hasUsedGiphy: true,
          },
        }
        this.setCurrentUserAction({
          ...this.currentUser,
          ...userPayload,
        })
      }
    },
    trackUploadImage(source) {
      Utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_EDITOR,
        'Upload image',
        this.type,
        source,
        {
          slideId: this.slideActive.id,
        },
      )
    },
    // implement PasteImageMixin@uploadImgFromPaste
    uploadImgFromPaste(file) {
      if (this.selectedTab !== 'upload') return
      this.uploadFile([file])
      this.trackUploadImage('paste')
    },
    handleTabChange(selectedTab, previouslyCached = false) {
      this.setSelectedTabAction(selectedTab)
      this.noResultText = ''
      if (selectedTab === 'unsplash') {
        this.searchPhotoUnsplash()
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Upload image modal > Open Free Photo (Unsplash)',
        )
        return
      }

      if (selectedTab === 'giphy') {
        this.searchPhotoGiphy()
        if (!this.hasUsedGiphy) this._checkToUpdateUserHasUsedGiphy()
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Upload image modal > Open Giphy',
        )
      }

      if (selectedTab === 'myPhoto') {
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Upload image modal > Open My photo',
          previouslyCached ? 'Cached' : 'Change Tab',
        )
      }

      if (selectedTab === 'upload') {
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Upload image modal > Open Upload',
        )
      }
    },
    searchPhotoUnsplash: debounce(function (infinitePage, e) {
      if (this.previousSearchText !== this.text) {
        this.noMoreUnsplashResult = false
      }
      this.noResultText = ''
      let text = this.text || 'team'
      let page = 1
      if (infinitePage) {
        page = infinitePage
      }
      this.isLoadingImg = true
      text = encodeURIComponent(text)
      const payload = {
        text,
        page,
        imagesPerPage: 30,
      }
      this._handleSearchUnsplash(text, page, e, payload)
    }, 800),

    async _handleSearchUnsplash(text, page, e, payload) {
      const listElm = document.querySelector('#infinite-list')
      try {
        const res = await this.$http.post(Config.api.searchUnsplash, payload)
        if (text && res.body.total === 0) {
          this.noResultText = `We couldn't find any images matching "${this.text}" in Unsplash.`
        }
        if (text && page > res.body.total_pages) {
          this.noMoreUnsplashResult = true // To stop calling searchUnplash API when scroll to bottom
          this.isLoadingImg = false
          return
        }
        if (!e) {
          this.splashPhotos = res.body.results
        } else {
          this.splashPhotos.forEach((splash) => {
            res.body.results = res.body.results.filter((result) => {
              return result.id !== splash.id
            })
          })
          this.splashPhotos.push(...res.body.results)
        }
        if (page === 1 && listElm) {
          listElm.scrollTop = 0
        }
        this.previousSearchText = this.text
        this.isLoadingImg = false
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Unsplash > Search',
        )
        setTimeout(() => {
          if (!this.$refs['unsplash-search-input']) return
          this.$refs['unsplash-search-input'].focus()
        })
      } catch (error) {
        Utils.showToastError(this.$i18nPresenter.t('Search images failed. Please try again.'))
      }
    },

    unsplashInfinite() {
      this.noMoreGiphyResult = false
      const totalPagesNow = Math.round(this.splashPhotos.length / 30)
      const infinitePage = totalPagesNow + 1
      this.searchPhotoUnsplash(infinitePage, 'nextPage')
    },

    searchPhotoGiphy: debounce(function (currentInfLimit, infOffset, e) {
      if (this.previousSearchText !== this.text) {
        this.noMoreGiphyResult = false
      }
      this.noResultText = ''
      this.isLoadingImg = true
      let currentLimit
      let offset
      let text = this.text || 'team'
      if (!e) {
        currentLimit = 30
        offset = 0
      } else {
        currentLimit = currentInfLimit
        offset = infOffset
      }
      text = encodeURIComponent(text)
      const payload = {
        text,
        currentLimit,
        offset,
      }
      this._handleSearchGiphy(currentInfLimit, infOffset, text, e, payload)
    }, 800),

    async _handleSearchGiphy(currentInfLimit, infOffset, text, e, payload) {
      const listGiphy = document.querySelector('#infinite-giphy-list')
      try {
        const result = await this.$http.post(this.giphyType === 'gif' ? Config.api.searchGiphy : Config.api.searchGiphySticker, payload)
        if (text && !result.body.length) {
          if (infOffset > 0) {
            this.noMoreGiphyResult = true // To stop calling searchGiphy API when scroll to bottom
            this.isLoadingImg = false
            return
          }
          this.noResultText = `We couldn't find any images matching "${this.text}" in Giphy.`
        }
        if (!e) {
          this.giphyPhotos = result.body
        } else {
          this.giphyPhotos.forEach((giphy) => {
            result.body = result.body.filter((photo) => {
              return photo.id !== giphy.id
            })
          })
          this.giphyPhotos.push(...result.body)
        }
        if (currentInfLimit === 30 && infOffset === 0) {
          listGiphy.scrollTop = 0
        }
        this.isLoadingImg = false
        this.previousSearchText = this.text
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          this.giphyType === 'gif' ? 'Giphy > Search Gif' : 'Giphy > Search Sticker',
        )
        setTimeout(() => {
          if (!this.$refs['giphy-search-input']) return
          this.$refs['giphy-search-input'].focus()
        })
      } catch (error) {
        this.isLoadingImg = false
        Utils.showToastError(`${this.$i18nPresenter.t('Search images failed')}${error.body ? `: ${error.body}.` : '.'} ${this.$i18nPresenter.t('Please try again.')}`)
      }
    },

    getUnsplashImageUrl(unsplashPhotoObj) {
      // AHA-8204 - Xử lí load ảnh Unsplash bị chậm.
      // Nguyên nhân: do dùng ảnh RAW, nó nặng, nên thư viện Cropper nó load ảnh chậm.
      // Giải pháp: dùng ảnh optimized, cho phép width tối đa là 1920px
      if (unsplashPhotoObj.width > 1920) {
        return `${unsplashPhotoObj.urls.full}&w=1920`
      }
      return unsplashPhotoObj.urls.full
    },

    getGiphyImageUrl(item) {
      return item.images.original.url
    },

    giphyInfinite() {
      this.noMoreUnsplashResult = false
      let currentInfLimit = this.giphyPhotos.length
      const infOffset = currentInfLimit
      currentInfLimit += 30
      this.searchPhotoGiphy(currentInfLimit, infOffset, 'nextPage')
    },
    _updateShowQuestionImage() {
      const { slideActive } = this.$store.state
      if (slideActive.type !== 'multipleChoice' && slideActive.type !== 'imageChoice' && slideActive.type !== 'pickAnswer') {
        slideActive.showQuestionImage = true
        return
      }
      const payload = {
        showQuestionImage: !slideActive.multipleCountAnswer,
      }
      this._setSlideActive(payload)
      this._updateSlide(payload)
    },
    _setSlideActive(payload) {
      this.updateSlideActiveAction({
        showQuestionImage: payload.showQuestionImage,
      })
    },
    async _updateSlide(payload) {
      await this.$http.put(Config.api.updateSlide + this.$store.state.slideActive.id, payload)
        .then(() => {})
    },
    handleOKButtonOnModalUploadImageError() {
      this.hasErrorOnUploadingGiphy = false
    },
    handleGiphyTypeChange(type) {
      if (type !== this.giphyType) {
        this.noResultText = ''
        this.giphyPhotos = []
        this.giphyType = type
        this.searchPhotoGiphy()
      }
      if (this.giphyType === 'gif') {
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Upload image modal > Giphy > Click GIFs button',
        )
      }
      if (this.giphyType === 'sticker') {
        Utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Upload image modal > Giphy > Click Stickers button',
        )
      }
    },
  },
}
</script>

  <style lang="scss" scoped>
  @import "@/assets/scss/variable.scss";
  .list-image {
    position: relative;
    overflow: hidden;
    margin-top: 21px;
    .list-image--no-result {
      text-align: center;
      font-size: 1em;
    }
    @media (max-width: 768px) {
      margin-top: 11px;
    }
  }
  .uploading-text {
    font-size: 20px;
    font-weight: bold;
  }
  .hide-loading-image {
    opacity: 0;
  }

  .input-search {
    background-color: #ffffff;
    z-index: 1;
    width: 100%;
    & ::v-deep {
      .spinner {
        position: absolute;
        text-align: center;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
      }
    }
  }
  .dropzone-custom-title {
    b {
      color: $primary-color;
    }
  }
  .fa-image {
    margin-bottom: 24px;
    margin-top: 8px;
  }
  .p-subtitle {
    color: #b9b9b9;
  }
  .image-upload-done {
    text-align: center;
    img {
      max-height: 400px;
    }
  }

  .img-info {
    position: absolute;
    bottom: 0;
    background: #0000005e;
    color: #ffffff;
    font-size: 13px;
    padding: 5px;
    text-align: center;
    display: none;
    width: 100%;
    .img-info__link, .img-info__unsplash-link {
      color: #ffffff !important;
    }
    img {
      width: 50%;
    }
  }
  .item-image {
    width: 25%;
    float: left;
    padding: 5px;

    .img-bg {
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      height: 160px;
      position: relative;

      .img-info__link {
        text-decoration: underline !important;
      }

      &:hover {
        cursor: pointer;
        .img-info {
          display: block;
        }
      }
    }
  }

  .subtitle {
  margin-bottom: 6px;
}

.highlight-mark {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: #FF4954;
  border-radius: 50%;
  vertical-align: middle;
}

  .btn-giphy{
    &--type{
      display: flex;
      .item{
        padding: 8px 16px;
        border-radius: 40px;
        background-color: #fff;
        border: 1px solid #D3D7E1;
        cursor: pointer;
        margin-left: 8px;
        transition: all 0.3s ease;
        display: inline-block;
        &.giphyType{
          margin-left: 4px;
        }
        &.active{
          background-color: #348EF6;
          color: #fff;
          border-color: #348EF6;
        }
        &.gif{
          @media (max-width: 768px) {
            margin-left: 0;
          }
        }
        &.gif, &.sticker {
          @media (max-width: 768px) {
            padding: 0 10px;
            display: flex;
            align-items: center;
            font-size: 0.8em;
            height: 35px;
          }
        }
        &:not(.active){
          &:hover, &:focus{
            border-color: #348EF6;
            color: #348EF6;
          }
        }
      }
      .bg-giphy-type{
        width: 103px;
        height: 38px;
        background-color: red;
        left: 0;
        top: 0;
      }
      @media (max-width: 768px) {
        margin-top: 8px;
     }
    }
  }

  .search-giphy-group{
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 768px) {
      flex-wrap: wrap;
   }
  }
.item-image-group{
  position: relative;
  .bg-sticker{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-image: url('../../assets/images/bg-tile-dark.png');
  }
}
.tab-giphy {
  &.__wrapper {
    display: inline-flex !important;
  }
  &.__icon {
    width: 30px;
    display: block;
    margin-left: 0.125rem;
    margin-top: -2px;
  }
}

.list-giphy-container{
  overflow-y: overlay !important;
}
</style>
